<jhi-alert></jhi-alert>
<jhi-bary-card>
  <div body>
    <jhi-bary-table-manager body #manager [type]="QUOTES" [service]="quotationsService" [tableOptions]="{ state: 'OLD' }">
      <jhi-quotations-list
        [transports]="manager.getData()"
        [(pagination)]="manager.pagination"
        [tableOptions]="manager.tableOptions"
        (paginationChange)="manager.transition()"
      ></jhi-quotations-list>
    </jhi-bary-table-manager>
    <div class="d-flex alert alert-info align-items-center">
      <jhi-bary-icon icon="info-circle" size="2x" class="mr-1"></jhi-bary-icon>
      <span jhiTranslate="baryApp.quotations.old.user-text"></span>
    </div>
  </div>
</jhi-bary-card>
